import React from 'react';
import t from 'react-translate';
import { config } from '@config/pendo.config.json';
import { Tab as TabType } from 'athena/components/responsive-tabs';

import ProgramSetup from './program-setup';
import ProgramProfileSetup from './program-profile-setup';
import MatchingSettings from './matching-settings';
import FeedbackSettings from './feedback-settings';
import Guidance from './guidance';
import ProgramWrapUp from './program-wrap-up';

export type Tab = TabType & {
  allowed: boolean;
  Component: React.ComponentType;
};

export const getTabsConfig = (isAdmin: boolean): Tab[] => [
  {
    id: 'program',
    allowed: isAdmin,
    Component: ProgramSetup,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_SETUP.TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.programSetup,
  }, {
    id: 'profile',
    allowed: isAdmin,
    Component: ProgramProfileSetup,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_PROFILE_SETUP.TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.programProfileSetup,
  }, {
    id: 'matching',
    allowed: isAdmin,
    Component: MatchingSettings,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.MATCHING_SETTINGS.MATCHING_TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.matchingSettings,
  }, {
    id: 'guidance',
    allowed: isAdmin,
    Component: Guidance,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.guidance,
  }, {
    id: 'feedback',
    allowed: isAdmin,
    Component: FeedbackSettings,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.FEEDBACK_SETTINGS.TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.feedbackSettings,
  }, {
    id: 'wrap-up',
    allowed: isAdmin,
    Component: ProgramWrapUp,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_WRAP_UP.TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.programWrapUp,
  },
];
